(() => {
    const initAll = () => {
        document.querySelectorAll('.imageLazy img[loading="lazy"]').forEach((img) => {
            const loaded = () => {
                img.parentNode.classList.add('loaded')
            };
            if (img.complete && img.naturalWidth > 0) {
                loaded();
            } else {
                img.addEventListener("load", loaded)
            }
        })
    };
    window.addEventListener("load", initAll);
})();
